/* unplugin-vue-components disabled */import { render } from "./DataRender.vue?vue&type=template&id=5b100563&ts=true"
import script from "./DataRender.vue?vue&type=script&lang=ts"
export * from "./DataRender.vue?vue&type=script&lang=ts"

import "./DataRender.vue?vue&type=style&index=0&id=5b100563&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__